import React from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import ShortcutButton from '../shortcut-button/ShortcutButton';
import { closeWizard } from './logActivityReducer';
import successGif from './successthumbsup.gif';

@connect(
    state => ({
        contacts: state.activeClient.contacts,
        participatingContactId: state.logActivityWizard.callData.participatingContactId,
    }),
    { closeWizard, push }
)
export default class SuccessScreenStep extends React.Component {
    closeAndBackToDashboard = () => {
        this.props.closeWizard();
        this.props.push('/');
    }
    render() {
        return(
            <div className="wizard-step-wrapper" style={{alignItems: 'center'}}>
                <img style={{height: 120, width: 120, background: '#fff', borderRadius: 120}} src={successGif} />
                <h1 style={{marginTop: 20, marginBottom: 40}}>All saved, nice work!</h1>
                <div style={{display: 'flex'}}>
                    <ShortcutButton shortcut="c" type="primary" onClick={this.props.closeWizard}>
                        Close
                    </ShortcutButton>
                    <ShortcutButton shortcut="d" type="success" onClick={this.closeAndBackToDashboard}>
                        Dashboard
                    </ShortcutButton>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./app/components/schedule-wizard/SuccessScreenStep.js